// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-d3533aca]{padding:0;list-style-type:none}.link[data-v-d3533aca],li[data-v-d3533aca]{cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
